import { ReactHintModal } from 'component/Modal/HintModal'
import {
  FooterSpacer,
  PlaceboChooserModalItem,
  PlaceboChooserModalItemButton,
  PlaceboChooserModalNav,
  PlaceboChooserModalNavCloseButton,
  PlaceboChooserModalTitle,
  PlaceboChooserModalWrapper,
} from './index.styled'
import { Styles } from 'react-modal'
import { animated, easings, useSpring } from '@react-spring/web'

export default function PlaceboChooserModal({
  isOpen,
  onClose,
  onClickOption,
}: {
  isOpen: boolean
  onClose: () => void
  onClickOption: (option: string) => void
}) {
  const styles: Styles = {
    overlay: {
      zIndex: 'calc(var(--layer-fullpage-modal) + 2)',
      backgroundColor: 'rgba(16, 4, 27, 0.5)',
      width: '100vw',
      height: '100vh',
    },
    content: {
      position: 'absolute',
      top: 'auto',
      bottom: 0,
      left: 0,
      right: 0,
      padding: 0,
      borderRadius: 0,
      background: 'transparent',
      borderStyle: 'none',
    },
  }
  const springStyles = useSpring({
    config: { duration: 150, easing: easings.easeInCubic },
    width: '100%',
    height: isOpen ? '100%' : '0',
    opacity: isOpen ? 1 : 0.2,
  })
  return (
    <ReactHintModal
      contentLabel="Hint Modal"
      isOpen={isOpen}
      style={styles}
      shouldCloseOnOverlayClick={true}
      onRequestClose={onClose}
    >
      <animated.div style={springStyles}>
        <PlaceboChooserModalWrapper>
          <PlaceboChooserModalNav>
            <PlaceboChooserModalTitle>切换线路</PlaceboChooserModalTitle>
            <PlaceboChooserModalNavCloseButton onClick={onClose} />
          </PlaceboChooserModalNav>
          <PlaceboChooserModalItem>
            线路1
            <PlaceboChooserModalItemButton type="button" onClick={() => onClickOption('线路1')}>
              立即切换
            </PlaceboChooserModalItemButton>
          </PlaceboChooserModalItem>
          <PlaceboChooserModalItem>
            线路2
            <PlaceboChooserModalItemButton type="button" onClick={() => onClickOption('线路2')}>
              立即切换
            </PlaceboChooserModalItemButton>
          </PlaceboChooserModalItem>
          <PlaceboChooserModalItem>
            线路3
            <PlaceboChooserModalItemButton type="button" onClick={() => onClickOption('线路3')}>
              立即切换
            </PlaceboChooserModalItemButton>
          </PlaceboChooserModalItem>
          <FooterSpacer />
        </PlaceboChooserModalWrapper>
      </animated.div>
    </ReactHintModal>
  )
}
